<script>
import axios from "axios";
import WaitingPageSpinner from "../../../common/components/WaitingPageSpinner.vue";
import Carousel from "../../../common/components/Carousel.vue";

export default {
    name: 'WaitingPage',
    components: {Carousel, WaitingPageSpinner},
    data() {
        return {
            lead_type: '',
            timer: '',
            waiting: false,
            waitingPercentage: 0,
            processing_time: 360,
            called_stop_timer: false,
            mainColor: themeSettings.general.main_color.value,
            userName: 'Alice'
        }
    },
    computed: {
        displayLeadType() {
            return this.lead_type === 'payday' ? 'short term' : this.lead_type;
        },
        bulletColor() {
            return {
                '--bullet-color': this.mainColor,
            };
        },
        textHighlightColor() {
            return  this.mainColor;
        },
        slides() {
            return [
                {
                    content: `<div><p>Please wait while we work to connect you with a ${this.displayLeadType} loan...<br>
                                      Due to the number of available lenders, <b style="color: ${this.textHighlightColor};">this can take up to 5 minutes</b></p>
                                      <p><b style="color: ${this.textHighlightColor};">DO NOT Close</b> your browser or press your “back” button</p>
                                      <p>If approved, you could get your funds from lenders as soon as the next business day.</p></div>`
                },
                {
                    content: `<div><p>Multiple lenders are currently still evaluating your submission for approval.</p>
                                   <p>Please stay on this page and <b style="color: ${this.textHighlightColor};">Do Not Click Back Button or Exit or Close</b> your mobile browsers.</p></div>`
                },
                {
                    content: `<div><p>Please <b style="color: ${this.textHighlightColor};">Do Not Close</b> or exit your mobile browsers. As soon as our lenders make their decision, you will be redirected to the lenders lander.</p></div>`
                },
            ]
        },
        userFirstName() {
            return this.$parent.fields?.first_name || 'Customer';
        }
    },
    methods:{
        calculateDelay(){
            return this.processing_time / (31 * 20);
        },
        setNewTimer(delay,maxPercentage){
            this.timer = setInterval(() => {
                this.waitingPercentage += 1;
                if (this.waitingPercentage >= 99) {
                    clearInterval(this.timer);
                    return;
                }
                if (this.waitingPercentage >= maxPercentage) {
                    clearInterval(this.timer);
                    this.setNewTimer(delay * 2, maxPercentage + 20);
                }
            }, delay);
        },
        startTimer() {
            window.isWaitingPageVisible = true;
            window.onbeforeunload = function(){
                return 'Are you sure you want to leave?';
            };
            this.called_stop_timer = false;
            this.$parent.waiting = this.waiting = true;
            this.lead_type = this.$parent.fields.lead_type;
            this.waitingPercentage = 0;

            this.$nextTick(() => {
                const waitingPageElement = document.getElementById("waitingPage");
                if (waitingPageElement) {
                    const styles = window.getComputedStyle(waitingPageElement);
                    if (styles.display !== 'none' && styles.visibility !== 'hidden') {
                        waitingPageElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }
            });
            axios.get(import.meta.env.VITE_API_GET_USER).then((response) => {
                if(response.data.processing_time != null){
                    this.processing_time = response.data.processing_time;
                }
                this.setNewTimer(this.calculateDelay() * 1000,20);
            }).catch((error) => {
                console.error(error);
            });
        },
        stopTimer(callback_after_stop_timer = false) {
            window.isWaitingPageVisible = false;
            window.onbeforeunload = null;
            clearInterval(this.timer);
            this.timer = setInterval( () => {
                this.waitingPercentage += 1;
                if (this.waitingPercentage >= 99){
                    clearInterval(this.timer);
                    this.$parent.waiting = this.waiting = false;
                    if(callback_after_stop_timer && !this.called_stop_timer){
                        this.called_stop_timer = true;
                        callback_after_stop_timer(this.$parent);
                    }
                }
            }, 15);
        }
    },
};

</script>

<template>
    <div v-show="waiting" class="row" id="waitingPage">
        <div style="text-align:center; padding: 50px 20px 0 20px">
            <p class="title-step mt-auto bd-highlight">Thank you <b :style="{ color: textHighlightColor }">{{ userFirstName }}</b>, please wait while we continue to process your request.</p>
        </div>
        <div style="width: 100vw; margin: auto; margin-bottom: 20px; max-width: 600px; padding: 50px 20px 0 20px">
            <WaitingPageSpinner :waiting-percentage="waitingPercentage" ></WaitingPageSpinner>
            <div style="padding: 5px; margin-top: 20px;">
                <Carousel :slides="slides" :interval="10000" v-if="waiting" />
                <p style="text-align: left; margin: auto; margin-bottom: 5px; font-size: 22px; font-weight: 600; line-height: 22px; font-family: Inter, serif; margin-top: 50px;">
                    To speed up your process, please be sure to:
                </p>
                <ul class="advice-list">
                    <li :style="bulletColor">Answer your phone-Your lender will be contacting you to verify your information shortly.</li>
                    <li :style="bulletColor">Check your SMS messages and Email for Notifications from your lender.</li>
                    <!--<li :style="bulletColor">Review and sign the loan documents provided by your lender.</li>-->
                </ul>
            </div>
        </div>
    </div>
</template>

<style scoped>

.advice-list {
    padding-top: 40px;
    list-style: none;
    padding-left: 0;
    margin: 0 auto;
}

.advice-list li {
    margin-top: 20px;
    position: relative;
    text-indent: 30px;
}

.advice-list li::before {
    content: "";
    width: 16px;
    height: 16px;
    border-radius: 50%;
    position: absolute;
    left: 0;
    top: 3px;
    background-color: var(--bullet-color);
}

</style>

